'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-field/node_modules/core-js/internals/array-slice.js
// module id = 1442
// module chunks = 0